import KpPaymentFormModal from './KpPaymentFormModal.svelte';
import KpPaymentGatewayRedirectModal from './KpPaymentGatewayRedirectModal.svelte';

export default class PaymentFormController {
    public static readonly controllerName = 'PaymentFormController';

    public kpPaymentFormModal = KpPaymentFormModal;
    public kpPaymentGatewayRedirectModal = KpPaymentGatewayRedirectModal;
}
